import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { AxiosRequestConfig } from 'axios'
import type { IApplicationInfo } from '~/types/application-info'

import { listApplicationsInfo } from '~/api/applications-info'

////////// KEYS //////////

export const keys = {
  all: ['applications-info'] as const,
  list: (clientId: string, params?: AxiosRequestConfig['params']) => [...keys.all, 'list', clientId, params] as const,
}

////////// QUERIES //////////

export const useApplicationsInfoListQuery = (
  clientId: string,
  params?: AxiosRequestConfig['params']
): UseQueryResult<IApplicationInfo[], unknown> => {
  return useQuery({
    enabled: !!clientId,
    queryFn: () => listApplicationsInfo(clientId, params),
    queryKey: keys.list(clientId, params),
  })
}
